module.exports = __webpack_public_path__ + "media/images/dropdown_arrow-bc8756e485f5befabb21d7f435d61181.svg";